{
  "version": 1,
  "routes": [
    { "key": "tts", "title": "Озвучка", "section": "tts" },
    { "key": "tts_s2s", "title": "Голос для переозвучки записи", "section": "tts", "filter": "s2s" },
    { "key": "clone", "title": "Клон", "section": "clone" },
    { "key": "studio", "title": "Студия", "section": "studio" },
    { "key": "balance", "title": "Баланс", "section": "balance" },
    { "key": "rewards", "title": "Награды и задания", "section": "rewards" },
    { "key": "history", "title": "История", "section": "history" },
    { "key": "profile", "title": "Профиль", "section": "profile" },
    { "key": "settings", "title": "Настройки", "section": "settings" },
    { "key": "help", "title": "Поддержка", "section": "help" },
    { "key": "partner", "title": "Партнёрство", "section": "partner" },
    { "key": "script", "title": "Озвучка проектов", "section": "studio", "screen": "script" },
    { "key": "voice", "title": "Сменить голос в записи", "section": "studio", "screen": "voice", "mode": "other", "out": "file" },
    { "key": "stt", "title": "Текст из аудио и видео", "section": "studio", "screen": "text", "tool": "stt" },
    { "key": "promo", "title": "Промокод", "section": "balance", "sheet": "promo" },
    { "key": "language", "title": "Язык и валюта", "section": "settings", "sheet": "language" }
  ]
}
